/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import * as S from './styles';

export interface IHeroButtonProps {
  buttons: {
    key: string;
    title: string;
    color: 'primary' | 'secondary' | '';
    link?: string;
  };
  onHeroButtonClick?(key: string): void;
}

function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}

export const HeroButtons = (props: IHeroButtonProps) => {
  const { buttons, onHeroButtonClick } = props;

  const onButtonClick = (item: any) => {
    if (item?.link && isValidHttpUrl(item.link)) {
      window.open(
        item.link,
        '_blank' // <- This is what makes it open in a new window.
      );
    } else {
      onHeroButtonClick && onHeroButtonClick(item?.key);
    }
  };

  return (
    <S.ButtonContainer className="mb-3 mt-3">
      {buttons?.map((item) => {
        return (
          <S.btn
            rounded
            onClick={onButtonClick.bind(null, item)}
            variant={item?.color}
            style={{ backgroundColor: item?.bgColor }}
            className="mx-2 my-2"
          >
            {item?.title}
          </S.btn>
        );
      })}
    </S.ButtonContainer>
  );
};

HeroButtons.defaultProps = {
  buttons: [],
};
